import {Tone} from "../../../../components/kit";

/** Estado de una presentación (modelos fiscales y libros de IVA): etiqueta y tono (#13879). */
export const TAX_STATUS: Record<string, { label: string, tone: Tone }> = {
	PENDIENTE: {label: "Pendiente", tone: "warning"},
	PRESENTADO: {label: "Presentado", tone: "info"},
	ACEPTADO: {label: "Aceptado", tone: "success"},
	RECHAZADO: {label: "Rechazado", tone: "error"},
};

export const taxStatus = (s?: string | null) => TAX_STATUS[s || "PENDIENTE"] || {label: s || "—", tone: "neutral" as Tone};

/** Columna numérica: alineada a la derecha y con cifras de ancho fijo. */
export const numSx = {fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap"} as const;

/** Nombre corto de cada modelo para los listados: «303 · IVA trimestral». */
export const TAX_MODEL_LABEL: Record<string, string> = {
	M303_IVA: "303 · IVA",
	M111_IRPF: "111 · Retenciones IRPF",
	M190_IRPF_ANUAL: "190 · Resumen anual IRPF",
	M202_IS: "202 · Pago fraccionado IS",
	M200_IS_ANUAL: "200 · Impuesto sobre Sociedades",
	M390_IVA_ANUAL: "390 · Resumen anual IVA",
	M347_TERCEROS: "347 · Operaciones con terceros",
	M115_ALQUILER: "115 · Retenciones alquiler",
	M180_ALQUILER_ANUAL: "180 · Resumen anual alquiler",
	M349_INTRACOMUNITARIO: "349 · Intracomunitarias",
	M130_IRPF_AUTONOMO: "130 · Pago fraccionado IRPF",
	LEGALIZACION_LIBROS: "Legalización de libros",
	APROBACION_CUENTAS: "Aprobación de cuentas",
	DOCUMENTACION_DEPOSITO: "Documentación del depósito",
	DEPOSITO_CUENTAS: "Depósito de cuentas",
	SEGUROS_SOCIALES: "Seguros sociales",
	PAGO_NOMINAS: "Pago de las nóminas",
};

const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre",
	"Octubre", "Noviembre", "Diciembre"];

/** «Octubre» para las mensuales (M10, #14014); el periodo tal cual para los demás. */
export const periodLabel = (period?: string | null) => {
	const m = /^M(\d\d)$/.exec(period || "");
	return m ? MESES[Number(m[1]) - 1] : period;
};
